import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Store from "../../Store/Store";

class JoinAgencyRoom extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    props.socket.emit("join", { room: Store.getConfigurator().getState().app.session.user.agencyId });
  }

}

export { JoinAgencyRoom };
